import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import './EditCalibrationDevice.css';

const EditCalibrationDevice = ({ userRole }) => {
  const { id } = useParams(); // This should be the SerialNumber
  const navigate = useNavigate();
  const [device, setDevice] = useState(null);
  const [loading, setLoading] = useState(true);
  const [deleteConfirmation, setDeleteConfirmation] = useState('');
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);

  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchDevice = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}/api/calibration-device/${id}`);
        setDevice(response.data);
      } catch (error) {
        console.error('Error fetching device:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchDevice();
  }, [id, apiBaseUrl]);

  const handleBack = () => {
    navigate('/calibration-devices');
  };

  const handleSave = async () => {
    try {
      const updatedDevice = {
        category: device.Category,
        owningLocation: device.OwningLocation,
        manufacturer: device.Manufacturer,
        modelNumber: device.ModelNumber,
        sesNumber: device.SESNumber,
      };
  
      await axios.put(`${apiBaseUrl}/api/calibration-device/${id}`, updatedDevice);
      alert('Device updated successfully');
      navigate(`/calibration-device/${id}`);
    } catch (error) {
      console.error('Error updating device:', error);
      alert('Error updating device: ' + error.message);
    }
  };
  

  const handleDelete = async () => {
    if (deleteConfirmation !== device.SerialNumber) {
      alert('Serial Number does not match. Please enter the correct Serial Number to confirm deletion.');
      return;
    }
    try {
      await axios.delete(`${apiBaseUrl}/api/calibration-device/${id}`);
      alert('Device deleted successfully');
      navigate('/calibration-devices');
    } catch (error) {
      console.error('Error deleting device:', error);
      alert('Error deleting device: ' + error.message);
    }
  };

  const onInputChange = (e) => {
    const { name, value } = e.target;
    setDevice({ ...device, [name]: value });
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!device) {
    return <div>Device not found</div>;
  }

  return (
    <div className="edit-device-container">
      <h1>Edit Calibration Device</h1>
      <div className="device-details">
        <p><strong>Serial Number:</strong> {device.SerialNumber}</p>
        <p>
          <strong>Category:</strong>
          <input type="text" name="Category" value={device.Category} onChange={onInputChange} />
        </p>
        <p>
          <strong>Owning Location:</strong>
          <input type="text" name="OwningLocation" value={device.OwningLocation} onChange={onInputChange} />
        </p>
        <p>
          <strong>Manufacturer:</strong>
          <input type="text" name="Manufacturer" value={device.Manufacturer} onChange={onInputChange} />
        </p>
        <p>
          <strong>Model Number:</strong>
          <input type="text" name="ModelNumber" value={device.ModelNumber} onChange={onInputChange} />
        </p>
        <p>
          <strong>SES Number:</strong>
          <input type="text" name="SESNumber" value={device.SESNumber} onChange={onInputChange} />
        </p>
      </div>
      <button onClick={handleSave} className="edit-device-save-button">Save</button>
      <button onClick={handleBack} className="edit-device-back-button">Back</button>
      {userRole === 'Admin' && (
        <>
          <button onClick={() => setShowDeleteDialog(true)} className="delete-device-button">Delete Device</button>
          {showDeleteDialog && (
            <div className="delete-dialog">
              <p>Type the Serial Number to confirm deletion:</p>
              <input type="text" value={deleteConfirmation} onChange={(e) => setDeleteConfirmation(e.target.value)} />
              <button onClick={handleDelete} className="confirm-delete-button">Confirm Delete</button>
              <button onClick={() => setShowDeleteDialog(false)} className="cancel-delete-button">Cancel</button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default EditCalibrationDevice;
